// extracted by mini-css-extract-plugin
export default {"edit-btn":"styles_edit-btn__ng71+"};